import type { UseTranslationResponse } from "react-i18next";

import { ProcessStatusEnum } from "../../enums";
import type { IRydeProcess } from "../../models";
import { isProcessCanceledByUser } from "../process.helpers";

interface IResolveProcessProgressTitleArguments {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: UseTranslationResponse<any, any>["t"];
  process: IRydeProcess | undefined;
  defaultTitle: string;
  isAborting?: boolean;
}

export const resolveProcessProgressTitle = ({
  t,
  process,
  defaultTitle,
  isAborting,
}: IResolveProcessProgressTitleArguments): string => {
  if (isAborting) {
    return t("process.aborting");
  }

  if (process?.status === ProcessStatusEnum.Pending) {
    return defaultTitle;
  }

  if (isProcessCanceledByUser(process)) {
    return t("process.aborted");
  }

  if (process?.status === ProcessStatusEnum.Failed) {
    return t("process.errors");
  }

  return defaultTitle;
};
